import React, { memo } from 'react';
import classNames from 'classnames';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import Heading, { HeadingTypes } from '../Heading/Heading';

interface QuoteFormHeadingBarProps {
  heading: string;
  isBottomBorderRequired: boolean;
}

const QuoteFormHeadingBar: React.FC<QuoteFormHeadingBarProps> = ({
  heading,
  isBottomBorderRequired,
}) => {
  return (
    <Grid>
      <Col span={{ md: 10, lg: 12, xxl: 10 }} start={{ md: 2, lg: 1, xxl: 2 }}>
        <div
          className={classNames(
            'flex items-end justify-center text-center pt-14 pb-6 sm:pt-20 sm:pb-7 sm:justify-start sm:text-left',
            {
              'border-b border-b-border/default': isBottomBorderRequired,
            }
          )}
        >
          <Heading text={heading} headingType={HeadingTypes.h1} />
        </div>
      </Col>
    </Grid>
  );
};

export default memo(QuoteFormHeadingBar);
